import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { LoginContext } from "../AuthContext/LoginContext";
import { ToastContainer } from 'react-toastify';

const SignInLayer = () => {
  const { login } = useContext(LoginContext);
  const [showPassword, setShowPassword] = useState(false);
  const [loginDetails, setLoginDetails] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginDetails({ ...loginDetails, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loginDetails.email === "" || loginDetails.password === "") {
      alert("Please enter details");
    } else {
      setLoading(true);
      await login(loginDetails.email, loginDetails.password);
      setLoading(false);
    }
  };

  return (

    <section className="auth-container">
      <ToastContainer />

      <div className="frosted-glass-card">
        <div className="card-content">
          <Link to="/" className="logo-link">
            <div className="flex items-center">
              <img
                src="assets/images/logo_fw.png"
                alt="Logo"
                className="logo-image"
              />
            </div>
          </Link>
          <h4 className="card-title">Sign In to your Account</h4>
          <p className="card-subtitle">
            Welcome back! please enter your detail
          </p>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-field">
              <span className="form-icon pb-3">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                name="email"
                className="form-input"
                placeholder="Email"
                value={loginDetails.email}
                onChange={handleLoginChange}
              />
            </div>
            <div className="form-field password-field">
              <div className="form-field">
                <span className="form-icon pb-3">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="form-input"
                  id="your-password"
                  placeholder="Password"
                  value={loginDetails.password}
                  onChange={handleLoginChange}
                />
              </div>
              <span
                className={`toggle-password ${!showPassword ? 'ri-eye-close-line' : 'ri-eye-line'}`}
                data-toggle="#your-password"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <div className="forgot-password">
              <Link to="/forgot-password" className="forgot-password-link">
                Forgot Password?
              </Link>
            </div>
            <button
              type="submit"
              className="submit-button  text-center"
              disabled={loading}
            >
              {loading ? (
                <span className="spinner" role="status" aria-hidden="true"></span>
              ) : (
                "Sign In"
              )}
              <div className="tutorials" style={{ marginTop: '1rem', textAlign: 'center' }}>
                <a href="https://gis-lab.s3.ap-southeast-1.amazonaws.com/Tutorials/Centralized+Complaint+Management+System+(Dashboard)-+User+Manual.pdf" target="_blank" rel="noopener noreferrer" className="tutorials-link ">
                  User Manual PDF
                </a>
                <span style={{ margin: '0 1rem' }}>|</span>
                <a href="https://gis-lab.s3.ap-southeast-1.amazonaws.com/Tutorials/Centralized+Complaint+Management+System+(Dashboard).mp4" target="_blank" rel="noopener noreferrer" className="tutorials-link ">
                  User Manual Video
                </a>
              </div>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;